import React from 'react';
import { useMatch } from 'react-router-dom';
import { useDatasourceId } from '@/hooks';
import { DATASOURCES_URL_PATH } from '@/routing/paths';
import { NavLink } from '@/components/MainSideBar/MainSidebar.styles';
import { MAIN_SIDEBAR_ITEM } from '@/constants/test-ids';
import { Tooltip } from '@trevor/ui-components';
import {
  CREDITS,
  DASHBOARDS,
  EXPLORER,
  MAP,
  REPORT,
  TEAM,
  VIEWS,
} from '@/util/enums/views.constants';

const TAB_TO_VIEW_PRELOAD_MAP: Record<string, any> = {
  [VIEWS]: () => import('@/views/SavedQueries'),
  [EXPLORER]: () => import('@/views/QueryBuilder'),
  [MAP]: () => import('@/components/er-diagram/MapContainer'),
  [TEAM]: () => import('@/containers/TeamAccess'),
  [CREDITS]: () => import('@/views/Credits'),
};

const TAB_TO_URL: Record<string, string> = {
  [EXPLORER]: '',
  [VIEWS]: '/saved-queries',
  [DASHBOARDS]: '/dashboards',
  [MAP]: '/map',
  [CREDITS]: '/credits',
  [TEAM]: '/team',
  [REPORT]: '/reports',
};

export const NavigationItem: React.FC<any> = ({
  tab,
  url,
  end = false,
  children,
  tooltipText,
  disabled = false,
  active = true,
}) => {
  const datasourceId = useDatasourceId();
  const preloadView = TAB_TO_VIEW_PRELOAD_MAP[tab] ?? (() => {});
  const to = url ?? `${DATASOURCES_URL_PATH}/${datasourceId}${TAB_TO_URL[tab]}`;
  const isActive = !!useMatch({ path: to, end: false });

  const handleClick = (e: React.MouseEvent) => {
    if (disabled) {
      e.preventDefault();
    }
  };

  return (
    <>
      <NavLink
        to={to}
        end={end}
        data-tooltip-id={tab}
        data-testid={`${MAIN_SIDEBAR_ITEM}:${tab}`}
        onClick={handleClick}
        onMouseOver={preloadView}
        onFocus={preloadView}
        $disabled={disabled}
        $canBeActiveHack={active}
      >
        {children}
      </NavLink>

      {!isActive && (
        <Tooltip id={tab} place="right">
          {tooltipText}
        </Tooltip>
      )}
    </>
  );
};
